<template>
  <main-template>
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between align-center">
          <h1>
            <v-btn color="primary" x-small text @click="goBack">
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            Gestão de Feriados
            <e-help-tooltip
              text="Cadastre e gerencie feriados nacionais, estaduais e municipais que impactam a apuração de horas de trabalho."
            />
          </h1>

          <div>
            <v-btn color="info" outlined class="mr-2" @click="abrirModalImportacao">
              <v-icon left small>mdi-calendar-import</v-icon>
              Importar do Calendário Letivo
            </v-btn>

            <v-btn color="primary" @click="abrirNovoFeriado">
              <v-icon left small>mdi-plus</v-icon>
              Novo Feriado
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="feriados"
              :loading="carregando"
              no-data-text="Nenhum feriado cadastrado."
            >
              <template v-slot:item.data="{ item }">
                {{ formatarData(item.data) }}
              </template>

              <template v-slot:item.tipo="{ item }">
                <v-chip
                  :color="tipoColor(item.tipo)"
                  small
                  dark
                  class="text-uppercase font-weight-bold"
                >
                  {{ item.tipo }}
                </v-chip>
              </template>

              <template v-slot:item.uf="{ item }">
                <span v-if="item.tipo === 'estadual' || item.tipo === 'municipal'">
                  {{ item.uf || item.estado || "PI" }}
                </span>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.acoes="{ item }">
                <v-btn icon small color="warning" class="mr-1" @click="editarFeriado(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>

                <v-btn icon small color="error" @click="confirmarExclusao(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal Novo / Editar Feriado -->
    <v-dialog v-model="dialogForm" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-3">
          {{ modoEdicao ? "Editar Feriado" : "Novo Feriado" }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="form" v-model="formValido">
            <v-text-field
              v-model="form.nome"
              label="Nome / Descrição do Feriado"
              outlined
              dense
              :rules="[rules.required]"
            />

            <v-text-field
              v-model="form.data"
              label="Data do Feriado"
              type="date"
              outlined
              dense
              :rules="[rules.required]"
            />

            <v-select
              v-model="form.tipo"
              :items="tiposFeriado"
              label="Tipo de Feriado"
              outlined
              dense
              :rules="[rules.required]"
            />

            <v-select
              v-if="form.tipo === 'estadual' || form.tipo === 'municipal'"
              v-model="form.uf"
              :items="ufs"
              item-text="codigo"
              item-value="codigo"
              label="UF (Estado)"
              outlined
              dense
              :rules="[rules.required]"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 justify-end">
          <v-btn text @click="dialogForm = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="salvando" :disabled="!formValido" @click="salvarFeriado">
            Salvar Feriado
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Importação Calendário Letivo -->
    <v-dialog v-model="dialogImportacao" max-width="700px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-3 d-flex justify-space-between align-center">
          <span>Importar Feriados do Calendário Letivo</span>
          <v-btn icon @click="dialogImportacao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="info" dense outlined class="mb-3">
            Selecione os feriados e recessos escolares identificados no Calendário Letivo para
            importar em lote:
          </v-alert>

          <v-data-table
            v-model="importacaoSelecionados"
            :headers="headersImportacao"
            :items="previewImportacao"
            :loading="carregandoPreview"
            show-select
            no-data-text="Nenhum feriado pendente de importação no calendário letivo."
            dense
          >
            <template v-slot:item.data="{ item }">
              {{ formatarData(item.data) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 justify-end">
          <v-btn text @click="dialogImportacao = false">Cancelar</v-btn>
          <v-btn
            color="success"
            :loading="importando"
            :disabled="importacaoSelecionados.length === 0"
            @click="executarImportacao"
          >
            Importar {{ importacaoSelecionados.length }} Feriados
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Exclusão -->
    <v-dialog v-model="dialogExclusao" max-width="450px">
      <v-card>
        <v-card-title class="headline text-h6 red--text">Excluir Feriado?</v-card-title>
        <v-card-text> Tem certeza de que deseja excluir este feriado? </v-card-text>
        <v-card-actions class="justify-end pa-4 pt-0">
          <v-btn text @click="dialogExclusao = false">Cancelar</v-btn>
          <v-btn color="error" :loading="excluindo" @click="excluirFeriado">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
import { $constants } from "@/plugins/constants";

const hoje = () => new Date().toISOString().slice(0, 10);

export default {
  name: "FeriadosPage",
  data() {
    return {
      carregando: false,
      feriados: [],
      headers: [
        { text: "Nome / Descrição", value: "nome" },
        { text: "Data", value: "data" },
        { text: "Tipo", value: "tipo" },
        { text: "UF", value: "uf" },
        { text: "Ações", value: "acoes", sortable: false, align: "right" },
      ],

      // Formulário
      dialogForm: false,
      modoEdicao: false,
      formValido: false,
      salvando: false,
      form: {
        id: null,
        nome: "",
        data: hoje(),
        tipo: "nacional",
        uf: "PI",
      },
      tiposFeriado: [
        { text: "Nacional", value: "nacional" },
        { text: "Estadual", value: "estadual" },
        { text: "Municipal", value: "municipal" },
      ],
      ufs: $constants.estadosList || [],

      // Exclusão
      dialogExclusao: false,
      feriadoParaExcluir: null,
      excluindo: false,

      // Importação
      dialogImportacao: false,
      carregandoPreview: false,
      importando: false,
      previewImportacao: [],
      importacaoSelecionados: [],
      headersImportacao: [
        { text: "Data", value: "data" },
        { text: "Descrição no Calendário", value: "nome" },
        { text: "Tipo", value: "tipo" },
      ],

      rules: {
        required: (v) => !!v || "Campo obrigatório.",
      },
    };
  },
  mounted() {
    this.carregarFeriados();
  },
  methods: {
    goBack() {
      this.$goBack();
    },
    async carregarFeriados() {
      try {
        this.carregando = true;
        const res = await this.$services.colaboradorPontosService.listarFeriados();
        this.feriados = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    tipoColor(tipo) {
      switch (tipo) {
        case "nacional":
          return "primary";
        case "estadual":
          return "success";
        case "municipal":
          return "warning";
        default:
          return "info";
      }
    },
    abrirNovoFeriado() {
      this.modoEdicao = false;
      this.form = {
        id: null,
        nome: "",
        data: hoje(),
        tipo: "nacional",
        uf: "PI",
      };
      this.dialogForm = true;
    },
    editarFeriado(item) {
      this.modoEdicao = true;
      this.form = {
        id: item.id,
        nome: item.nome || item.descricao || "",
        data: item.data ? item.data.split("T")[0] : hoje(),
        tipo: item.tipo || "nacional",
        uf: item.uf || item.estado || "PI",
      };
      this.dialogForm = true;
    },
    async salvarFeriado() {
      if (!this.$refs.form.validate()) return;
      try {
        this.salvando = true;
        if (this.modoEdicao) {
          await this.$services.colaboradorPontosService.atualizarFeriado(this.form.id, this.form);
        } else {
          await this.$services.colaboradorPontosService.cadastrarFeriado(this.form);
        }
        this.dialogForm = false;
        this.carregarFeriados();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvando = false;
      }
    },
    confirmarExclusao(item) {
      this.feriadoParaExcluir = item;
      this.dialogExclusao = true;
    },
    async excluirFeriado() {
      if (!this.feriadoParaExcluir) return;
      try {
        this.excluindo = true;
        await this.$services.colaboradorPontosService.excluirFeriado(this.feriadoParaExcluir.id);
        this.dialogExclusao = false;
        this.carregarFeriados();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindo = false;
      }
    },
    async abrirModalImportacao() {
      try {
        this.dialogImportacao = true;
        this.carregandoPreview = true;
        this.importacaoSelecionados = [];
        const res =
          await this.$services.colaboradorPontosService.previewImportacaoCalendarioLetivo();
        this.previewImportacao = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoPreview = false;
      }
    },
    async executarImportacao() {
      if (this.importacaoSelecionados.length === 0) return;
      try {
        this.importando = true;
        await this.$services.colaboradorPontosService.importarDoCalendarioLetivo({
          feriados: this.importacaoSelecionados,
        });
        this.dialogImportacao = false;
        this.carregarFeriados();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.importando = false;
      }
    },
    formatarData(val) {
      if (!val) return "";
      const datePart = val.split("T")[0];
      const [ano, mes, dia] = datePart.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>
